import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import { Link } from "react-router-dom";

const DepositoryServices = () => {
  useEffect(() => {
    if (window.jQuery && window.$.fn.tab) {
      window.$(".tab1").tab();
      window.$(".tab2").tab({ trigger_event_type: "mouseover" });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="depository-page">
      <SEO
        title="Depository Services"
        description="Secure Demat services for holding your investment securities with complete transparency. Facilitating smooth transactions and secure custody of assets."
      />

      <section className="service-banner">
        <img
          src="/images/banners/depository-banner.avif"
          alt="Depository Services Banner"
          loading="eager"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/depository-mobile-banner.avif"
          alt="Depository Services Mobile Banner"
          loading="eager"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1 data-aos="fade-up">
            Depository <span>Services</span>
          </h1>
          <div className="banner-highlights" data-aos="fade">
            <span>Invest</span>
            <span>Grow</span>
            <span>Secure</span>
          </div>
        </div>
      </section>

      <section className="offered-services">
        <div className="container">
          <div className="offered-services-left">
            <h2 data-aos="fade-up">
              <span>What</span> <br /> We Offer
            </h2>
            <p>
              Efficient custody and seamless administration of securities form
              the backbone of modern investing. Our Depository Services are
              designed to provide secure holding, smooth transactions, and
              regulatory-compliant record management of your financial assets in
              electronic form.
            </p>
            <p>
              By eliminating the risks associated with physical certificates,
              demat accounts ensure safety, transparency, and operational
              convenience. We facilitate end-to-end depository solutions that
              simplify portfolio management while maintaining strict compliance
              with exchange and regulatory guidelines.
            </p>
          </div>
          <div className="offered-services-right">
            <img
              src="/images/services/depository-offer.avif"
              alt="Depository and Demat Services Overview"
              loading="lazy"
            />
          </div>
        </div>

        <img
          src="/images/services/offer-bg.avif"
          alt=""
          className="offer-bg"
          aria-hidden="true"
        />
      </section>

      <section className="services-divider">
        <div className="services-divider-left"></div>
        <div className="services-divider-right"></div>
      </section>

      <section className="services-highlights">
        <div className="container">
          <div className="services-highlights-left">
            <h2 data-aos="fade-up">Key Highlights</h2>
            <p>
              Secure and convenient holding of your securities. Simplified
              transactions with enhanced safety and easy access to your
              investments.
            </p>
            <img
              src="/images/services/depository-highlight.png"
              alt="Depository Key Highlights Graphic"
              loading="lazy"
            />
          </div>

          <div className="services-highlights-right">
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Secure demat account services</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Dematerialization & rematerialization</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Pledge / unpledge facility</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Corporate action tracking</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Consolidated holding statements</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-disclaimer">
        <div className="container">
          <p>
            <b>Disclaimer</b>: Depository services are offered in association
            with registered depositories. Investors are advised to verify
            transaction statements periodically.
          </p>
        </div>
      </section>

      <section className="services-app-download">
        <div className="container">
          <div className="services-app-download-left">
            <img
              src="/images/download.avif"
              alt="Investment Fund Mobile App Preview"
              loading="lazy"
            />
          </div>
          <div className="services-app-download-right">
            <h3 data-aos="fade-up">
              Download Our <br /> Investment Fund App
            </h3>
            <p>Investing With Gateway Financial Services Limited</p>
            <Link to="/" className="download-btn lm-btn">
              Download Now
            </Link>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default DepositoryServices;
